import type { FunctionalComponent as FC } from 'vue'
import {
  useVideoView,
  useImgView,
  useImgsView,
} from '~/hooks/useModal/modals/view'

import { usePagPlayer } from '~/hooks/useModal/modals/pag/index'

type IProps = {
  data: any
}

export const usePlayView = (data: any, trackParams?: any) => {
  const { $t } = useNuxtApp()
  const { file_url, children, media_type } = data
  if (!file_url && !media_type) {
    return undefined
  }

  const suffix = file_url.split('?')?.[0].split('.').pop().toLowerCase()

  if (media_type) {
    if (
      (media_type === FILE_TYPE_MAP.PDF || media_type === FILE_TYPE_MAP.PPT) &&
      children?.length
    ) {
      useImgsView(children.map((item: { url: any }) => item.url))
    } else if (media_type === FILE_TYPE_MAP.PAG) {
      usePagPlayer(data)
    } else if (media_type === FILE_TYPE_MAP.IMAGE) {
      useImgView(file_url)
    } else if (media_type === FILE_TYPE_MAP.VIDEO) {
      if (['mov', 'mkv'].includes(suffix)) {
        message.warning(
          $t(
            'liu-lan-qi-zan-bu-zhi-chi-ci-ge-shi-shi-pin-bo-fang-qing-xia-zai-cheng-pian-hou-cha-kan'
          )
        )
        return
      }
      useVideoView(file_url, trackParams)
    }
  } else if (suffix) {
    if (['mov', 'mkv'].includes(suffix)) {
      message.warning(
        $t(
          'liu-lan-qi-zan-bu-zhi-chi-ci-ge-shi-shi-pin-bo-fang-qing-xia-zai-cheng-pian-hou-cha-kan'
        )
      )
      return
    }
    if (['mp4', 'mov', 'webm'].includes(suffix)) {
      useVideoView(file_url, trackParams)
    } else if (['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(suffix)) {
      useImgView(file_url)
    } else if (['ppt', 'pptx', 'pdf'].includes(suffix) && children?.length) {
      useImgsView(children.map((item: { url: any }) => item.url))
    } else if (suffix === 'pag') {
      usePagPlayer(data)
    }
  }
}

export const Play: FC<IProps> = (props) => {
  const handClick = (e: Event) => {
    e.stopPropagation()
    usePlayView(props.data)
  }
  return (
    <span
      class="absolute top-[10px] z-[1] right-[44px] w-[24px] h-[24px] bg-back-1 rounded-[50%] flex-center hover cursor-pointer hover:bg-back-5"
      onClick={handClick}
    >
      <svg
        class="w-[12px] h-[12px] -mr-[2px]"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 10 12"
      >
        <path
          d="M9.6 6.007c0 .354-.11.709-.327.993-.041.056-.232.286-.382.436l-.082.081c-1.145 1.24-3.995 3.105-5.44 3.702 0 .014-.86.369-1.269.381h-.055a1.716 1.716 0 0 1-1.513-.924C.368 10.362.218 9.45.205 9.438.082 8.62 0 7.368 0 5.993c0-1.441.082-2.749.232-3.552 0-.013.15-.748.245-.993.15-.353.423-.653.764-.844C1.514.47 1.8.4 2.1.4c.314.015.9.218 1.132.313 1.527.599 4.445 2.558 5.563 3.756.191.19.396.423.45.476.232.3.355.667.355 1.062Z"
          fill-rule="nonzero"
          fill="#6962FF"
          data-follow-fill="#6962FF"
        />
      </svg>
    </span>
  )
}
